import { connect } from 'react-redux';
import Steps       from '../components/Steps';

const mapStateToProps = state => ({
  quoteStep        : state.get('quoteStep'),
  parametersChanged: state.get('parametersChanged'),
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(Steps);
